import { render } from "./LangSwitch.vue?vue&type=template&id=93ccd04e&scoped=true&ts=true"
import script from "./LangSwitch.vue?vue&type=script&lang=ts"
export * from "./LangSwitch.vue?vue&type=script&lang=ts"

import "./LangSwitch.vue?vue&type=style&index=0&id=93ccd04e&lang=scss&scoped=true"

import exportComponent from "/Users/aleksandrvasilevic/Documents/Dev/WEB/Pets/phone-book/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93ccd04e"]])

export default __exports__